export default __webpack_public_path__ + "static/media/footer-img.12efbc11.png";